<app-widget-core [isClear]="isClear">

  <div class="widget-bar-chart">

    @if (title) {

      <div class="title">{{ title }}</div>

    }

    <div class="chart-wrap">

      @if (data) {

        <apx-chart
          [chart]="chartOptions.chart!"
          [responsive]="chartOptions.responsive!"
          [plotOptions]="chartOptions.plotOptions!"
          [dataLabels]="chartOptions.dataLabels!"
          [series]="chartOptions.series!"
          [xaxis]="chartOptions.xaxis!"
          [yaxis]="chartOptions.yaxis!"
        ></apx-chart>

      } @else {

        <div class="no-data-chart">
          <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        </div>

      }

    </div>

    <ng-content select="[extra-content]"></ng-content>

  </div>

</app-widget-core>
